import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import Loader from "./components/Loader/Loader";
import Router from "./Routes/Router";
import "./App.css";
import WarningDialog from "./components/WarningDialog/WarningDialog";
import { authActions } from "./store/slices/AuthSlice";

function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(authActions.setTableauTab("tableau"));
    const root = document.getElementById("tableau-container-root");
    if (!root) return;
    root.style.display = "none";
  }, [location]);

  return (
    <div className='App'>
      <WarningDialog />
      <Loader />
      <Router />
    </div>
  );
}

export default App;
